import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PermissionsService } from './permissions.service';
import { config } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class SummaryService {

  private apiUrl = `${config.examApiBaseUrl}/call`; // From ExamApp
  private assessmentsUrl = `${config.examApiBaseUrl}/exam/assessments`;


  constructor(private http: HttpClient, private permissionsService: PermissionsService) { }

  getUserBranchId(): Observable<any> {
    return new Observable<any>((observer) => {
      const keys = Object.keys(sessionStorage);
      keys.forEach((key) => {
        const value = sessionStorage.getItem(key);
        if (value !== null) {
          try {
            const parsedValue = JSON.parse(value);
            if (parsedValue && parsedValue.authorityType === "MSSTS") {
              this.permissionsService
                .getUserPermissions(parsedValue.username)
                .subscribe((response) => {
                  const matchedUser = response.result[0].find(
                    (user: { Email: any }) => user.Email === parsedValue.username
                  );
                  if (matchedUser) {
                                        observer.next({
                      branchId: matchedUser.branchId,
                      branchName: matchedUser.branchName
                    });
                    observer.complete();
                  } else {
                    observer.error("User not found");
                  }
                });
            }
          } catch (e) {
            observer.error(e);
          }
        }
      });
    });
  }


  getTodayAssessments(userBranchId: number): Observable<any> {
    return this.http.get<any>(`${this.assessmentsUrl}?userbranchid=${userBranchId}`);
  }

  getCandidatesCurrentlyTesting(){
      const body = {
      procedureName: 'getCandidatesCurrentlyTesting',
      params: {}
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  getCompletedExamsToday(): Observable<any> {
    const body = {
      procedureName: 'getCompletedExamsToday',
      params: {}
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  getUpcomingExamCandidates(from: string, to: Date, userBranchId: number): Observable<any> {
    const fromDate = from.split('T')[0];
    const toDate = to.toISOString().split('T')[0];
    return this.http.get<any>(`${this.assessmentsUrl}?from=${fromDate}&to=${toDate}&userbranchid=${userBranchId}`);
  }
  
}
